// src/api/reviewApi.js
import axios from "./axios";

/**
 * ---- Plan reviews ----
 * Backend endpoints (same contract as app):
 *  - GET  /api/reviews/plan/{planKey}
 *  - POST /api/reviews/plan       body: { planKey, rating, title?, comment? }
 */

export async function getPlanReviews(planKey) {
  if (!planKey) return [];
  const res = await axios.get(
    `/api/reviews/plan/${encodeURIComponent(planKey)}`
  );
  return Array.isArray(res.data) ? res.data : [];
}

export async function createPlanReview(planKey, payload) {
  if (!planKey) {
    throw new Error("planKey is required for createPlanReview");
  }
  const body = { planKey, ...(payload || {}) };
  const res = await axios.post("/api/reviews/plan", body);
  return res.data;
}

/**
 * ---- Vehicle (booking) reviews ----
 * Backend endpoints:
 *  - GET  /api/reviews/vehicle/{bookingId}
 *  - POST /api/reviews/vehicle     body: { bookingId, rating, title?, comment? }
 */

export async function getVehicleReviews(bookingId) {
  const id = Number(bookingId);
  if (!id) return [];
  const res = await axios.get(`/api/reviews/vehicle/${id}`);
  return Array.isArray(res.data) ? res.data : [];
}

export async function createVehicleReview(bookingId, payload) {
  const id = Number(bookingId);
  if (!id) {
    throw new Error("bookingId is required for createVehicleReview");
  }
  const body = { bookingId: id, ...(payload || {}) };
  const res = await axios.post("/api/reviews/vehicle", body);
  return res.data;
}
